var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenroadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#142833"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.571 297.816H206.6C193.182 297.816 181.369 290.837 181.369 276.878C181.369 262.919 191.577 255.94 206.6 255.94H251.156C304.85 255.94 344.658 223.409 349.896 174.331C354.376 132.545 333.603 94.2152 292.435 81.5502C254.299 69.8216 206.243 72.7871 174.861 99.0984C155.826 115.041 145.394 137.896 145.394 164.118C145.394 188.289 155.603 213.531 179.764 229.629C149.696 237.144 135.208 255.962 135.208 279.04C135.208 295.696 144.325 311.261 158.835 320.938C136.813 331.685 125 351.553 125 373.561C125 411.153 150.788 438 208.227 438H297.361C356.427 438 381.658 406.315 381.658 363.861C381.658 321.407 349.985 297.794 300.593 297.794L300.571 297.816ZM249.752 112.789C284.456 112.789 304.293 132.634 304.293 163.494C304.293 194.354 283.898 214.198 249.752 214.198C215.605 214.198 195.21 194.354 195.21 163.494C195.21 132.634 215.048 112.789 249.752 112.789ZM294.107 398.288H214.111C185.648 398.288 174.905 385.4 174.905 368.765C174.905 352.131 186.718 337.617 215.716 337.617H296.804C317.733 337.617 331.708 347.828 331.708 365.556C331.708 388.656 314.523 398.311 294.107 398.311V398.288Z",
    fill: "#1FFF48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387 75H340.684V121.334H387V75Z",
    fill: "#1FFF48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenroadIcon);
export default __webpack_public_path__ + "static/media/greenroad-icon.a5f78aa17b919c18280a7b911e18458f.svg";
export { ForwardRef as ReactComponent };